import {Stack, Typography, useTheme} from '@mui/material';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useBilletDetails} from '../../hooks/useBilletDetails';

const {
	billetDetails: {billetValue, billetValueNotredameSaude},
	interestFines,
} = translations['pt-br'].privateFlow.myFinancial;

const PriceInfoBillet = () => {
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();
	const {isNotredameSaude} = useHostName();

	const {isInNegotiation, isExpired, formattedPrice, textColor} = useBilletDetails();
	return (
		<Stack>
			<Typography fontSize={'0.875rem'} fontWeight={400} color={colors.light.text.secondary}>
				{isNotredameSaude ? billetValueNotredameSaude : billetValue}
			</Typography>
			<Stack
				alignItems={isMobile ? 'flex-start' : 'center'}
				color={textColor}
				direction={isMobile ? 'column' : 'row'}
				gap={isMobile ? 0 : 0.5}>
				<Typography
					fontSize={isMobile ? '1.25rem' : '1.5rem'}
					fontWeight={isMobile ? 600 : 400}>
					{formattedPrice}
				</Typography>
				{isInNegotiation || isExpired ? (
					<Typography fontSize={'0.75rem'}>{interestFines}</Typography>
				) : null}
			</Stack>
		</Stack>
	);
};

export {PriceInfoBillet};
